'use strict';

(function () {
  'use strict';

  angular.module('msOnboarding').controller('WelcomeCtrl', WelcomeCtrl);
  WelcomeCtrl.$inject = ['$rootScope', '$scope', '$state', '$stateParams', 'countryGdprConfig', 'providerSvc', 'onboardingRouter', 'customSignupSvc'];

  function WelcomeCtrl($rootScope, $scope, $state, $stateParams, countryGdprConfig, providerSvc, onboardingRouter, customSignupSvc) {
    $rootScope.$state = $state;
    $scope.accessCodeData = null;
    $scope.navigate = navigate;
    // Mobile webview variables
    $scope.isMobileYouthAccessCode = false;
    $scope.canNavigate = true;
    $scope.countryGdprConfig = null;

    $scope.isAccessCodeValidationInProgress = false;

    $scope.$on('setAccessCodeData', function (event, data) {
      $scope.accessCodeData = data;
      if (data) {
        $scope.countryGdprConfig = countryGdprConfig.getByCountryCode(data.country.countryCode, data.applicationMode.name);
      }
    });

    // Group dropdown - reset access code if group is null
    // Fixes navigation button validation when user sets group dropdown to empty value
    $scope.$watch('group', function (newValue) {
      if (newValue === null && $scope.groupField !== null) {
        $scope.accessCode = null;
      }
    });

    activate();

    function navigate() {
      if (!$scope.accessCode || !$scope.canNavigate) {
        return;
      }
      // Prevent duplicate navigation
      $scope.canNavigate = false;

      var provider = providerSvc.getProvider();
      provider.accessCode = $scope.accessCode;
      provider.preferences = null;
      providerSvc.setProvider(provider);

      if ($scope.accessCodeData && $scope.accessCodeData.organizationName && $scope.accessCodeData.organizationShortName) {
        providerSvc.setOrganization({
          name: $scope.accessCodeData.organizationName,
          shortName: $scope.accessCodeData.organizationShortName
        });
      }

      // Add isSubjectToGDPR to $stateParams
      if ($scope.countryGdprConfig.isSubjectToGDPR) {
        $stateParams.isSubjectToGDPR = true;
      }

      // Go to next step
      onboardingRouter.goToNextStep($stateParams);
    }

    function activate() {
      // Clear auth requirements
      onboardingRouter.clearRequirements();

      // save all the information about our provider in the service
      providerSvc.setProvider({
        organization: $stateParams.organization,
        group: $stateParams.group,
        accessCode: $stateParams.pc,
        referralToken: $stateParams.ref
      }).then(function (resp) {
        if (resp && resp.data === false) {
          onboardingRouter.navigate404();
        } else {
          providerSvc.getPreferences();
        }
      });
      $scope.group = $stateParams.group;
      // If the AC is not in the URL, show the field until we know we need to replace it
      if (!$stateParams.pc) {
        $scope.acField = customSignupSvc.getAcField();
        $scope.groupField = customSignupSvc.getGroupField();
      }
      // This does a couple of things:
      // 1. Sets up the custom signup questions for the account page to use
      // 2. Loads up the custom signup fields configured above in providerSvc
      // 3. Loads up any custom access code fields (dropdowns or custom text)
      customSignupSvc.setupCustomSignup($stateParams.pc).then(function () {
        if ($stateParams.pc) {
          // If the access code is present and the setup was valid, we remove the AC field from the page
          $scope.acField = null;
          // Set the access code so we can use it in the navigate function above
          $scope.accessCode = $stateParams.pc;
          // Validate $stateParams.pc & set
          customSignupSvc.checkAccessCode($stateParams.pc, $scope.group).then(function (data) {
            $scope.accessCodeData = data;
          });
        } else {
          // if there was a custom field set up based on the provider params, use it
          $scope.acField = customSignupSvc.getAcField();
          $scope.groupField = customSignupSvc.getGroupField();
        }
      });

      // If isMobileWebView watch for access code change
      // - insure is not a youth access code
      if ($rootScope.isMobileWebView) {
        _watchAccessCode();
      }
    }

    function _watchAccessCode() {
      var accessCodeYouth = 'YOUTH';

      $scope.$watch('accessCode', function (newValue) {
        if (!newValue) {
          return;
        }
        $scope.canNavigate = false;

        providerSvc.getAccessCodeType(newValue).then(function (resp) {
          if (resp.data && resp.data.accessCodeType === accessCodeYouth) {
            $scope.isMobileYouthAccessCode = true;
          }
          $scope.canNavigate = true;
        }, function () {
          $scope.canNavigate = true;
        });
      });
    }
  }
})();